import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

import { UserAuth } from '../../providers/user/user.auth';

import { HelpMenuDialogService } from './help-menu-dialog.service';

@Component({
  selector: 'help-menu-dialog',
  templateUrl: './help-menu-dialog.component.html',
  styleUrls: ['./help-menu-dialog.component.scss']
})
export class HelpMenuDialogComponent implements OnInit {
  @Input() filePath?: string = '/en/assets/persistent';
  @Output() clickCloseButton = new EventEmitter();
  helpMenuDataSource: any; //eslint-disable-line

  constructor(
    private readonly helpMenuService: HelpMenuDialogService,
    private readonly userAuth: UserAuth
  ) {}

  ngOnInit() {
    this.helpMenuDataSource = this.helpMenuService.menus;
  }

  closeHelpMenu(): void {
    this.clickCloseButton.emit(false);
  }

  //eslint-disable-next-line
  openDocument(item: any): void {
    //eslint-disable-line
    const documentURL = item.url;
    const prefixPath =
      this.filePath === 'doc' && documentURL.includes('certs') ? '' : this.filePath;
    window.open(documentURL.search('/') === 0 ? prefixPath + documentURL : documentURL, '_blank');
  }

  private isVisibleSubMenu(menu): boolean {
    if (menu && menu.documents && menu.documents[0]) {
      return menu.auth ? this.userAuth.isAuthedFor(menu.auth) : true;
    }
    return false;
  }
}
